import Vue from 'vue'
import Router from 'vue-router'
import TheSplash from '@/components/TheSplash'
import TheTimer from '@/components/TheTimer'
import Info from '@/components/Info'
import Blog from '@/components/Blog'
import ArticleDetail from '@/components/ArticleDetail'
import PreferencesMenu from '@/components/PreferencesMenu'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // Remember to update the sitemap with any changes below!
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        main: TheTimer,
        splash: TheSplash
      },
      props: true
    },
    {
      path: '/info',
      // alias: ['/help', '/contact'],
      name: 'Info',
      component: Info,
      // components: {
      //   main: TheTimer,
      //   tray: Info
      // }
    },
    {
      path: '/preferences',
      name: 'preferences',
      // component: PreferencesMenu,
      components: {
        main: TheTimer,
        tray: PreferencesMenu
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/blog/:slug',
      name: "ArticleDetail",
      component: ArticleDetail,
    },
    // {
    //   path: '*',
    //   redirect: {name: 'home'}
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js